import { render } from "./vehicle_consumption.vue?vue&type=template&id=23bd9ae3&scoped=true"
import script from "./vehicle_consumption.vue?vue&type=script&lang=js"
export * from "./vehicle_consumption.vue?vue&type=script&lang=js"

import "./vehicle_consumption.vue?vue&type=style&index=0&id=23bd9ae3&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23bd9ae3"]])

export default __exports__